var _g, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSExh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 40,
    viewBox: "0 0 85 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_59_2918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 18C4 9.16344 11.1634 2 20 2H65C73.8366 2 81 9.16344 81 18C81 26.8366 73.8366 34 65 34H20C11.1634 34 4 26.8366 4 18Z",
    fill: "#282D4B"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.054 11.73H37.12V13.199H42.801V11.73H43.88V16.423H36.054V11.73ZM37.12 14.057V15.552H42.801V14.057H37.12ZM34.637 17.671H45.258V18.555H34.637V17.671ZM39.421 15.916H40.487V18.061H39.421V15.916ZM36.015 21.87H44.088V22.754H36.015V21.87ZM36.015 19.504H37.094V22.169H36.015V19.504ZM51.836 14.499H54.8V15.383H51.836V14.499ZM54.189 11.275H55.268V19.881H54.189V11.275ZM47.767 21.87H55.593V22.754H47.767V21.87ZM47.767 19.127H48.846V22.325H47.767V19.127ZM48.599 12.731H49.483V13.68C49.483 15.812 48.157 17.658 46.194 18.386L45.635 17.528C47.39 16.904 48.599 15.344 48.599 13.68V12.731ZM48.807 12.731H49.678V13.667C49.678 15.188 50.822 16.67 52.525 17.268L51.979 18.113C50.068 17.424 48.807 15.656 48.807 13.667V12.731ZM45.973 12.224H52.252V13.095H45.973V12.224ZM59.662 12.276H60.546V14.382C60.546 17.086 59.09 19.595 57.166 20.57L56.503 19.686C58.245 18.854 59.662 16.605 59.662 14.382V12.276ZM59.844 12.276H60.728V14.382C60.728 16.527 62.132 18.685 63.874 19.491L63.224 20.349C61.313 19.413 59.844 16.995 59.844 14.382V12.276ZM65.096 11.249H66.175V23.027H65.096V11.249Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6667 18.57C23.6439 18.57 22.0001 20.2139 22.0001 22.2367C24.0228 22.2367 25.6667 20.5928 25.6667 18.57ZM18.3334 18.57C18.3334 20.5928 19.9773 22.2367 22.0001 22.2367C22.0001 20.2139 20.3562 18.57 18.3334 18.57ZM19.5556 17.3661C19.5556 17.8917 19.9834 18.3194 20.5089 18.3194C20.7106 18.3194 20.8939 18.2583 21.0528 18.1483L21.0467 18.2217C21.0467 18.7472 21.4745 19.175 22.0001 19.175C22.5256 19.175 22.9534 18.7472 22.9534 18.2217L22.9473 18.1483C23.1001 18.2522 23.2895 18.3194 23.4912 18.3194C24.0167 18.3194 24.4445 17.8917 24.4445 17.3661C24.4445 16.9872 24.2184 16.6572 23.9006 16.5044C24.2184 16.3578 24.4445 16.0278 24.4445 15.6489C24.4445 15.1233 24.0167 14.6956 23.4912 14.6956C23.2895 14.6956 23.1062 14.7567 22.9473 14.8667L22.9534 14.7933C22.9534 14.2678 22.5256 13.84 22.0001 13.84C21.4745 13.84 21.0467 14.2678 21.0467 14.7933L21.0528 14.8667C20.9001 14.7567 20.7106 14.6956 20.5089 14.6956C19.9834 14.6956 19.5556 15.1233 19.5556 15.6489C19.5556 16.0278 19.7817 16.3578 20.0995 16.5106C19.7817 16.6572 19.5556 16.9872 19.5556 17.3661ZM22.0001 15.5511C22.5256 15.5511 22.9534 15.9789 22.9534 16.5044C22.9534 17.03 22.5256 17.4578 22.0001 17.4578C21.4745 17.4578 21.0467 17.03 21.0467 16.5044C21.0467 15.9789 21.4745 15.5511 22.0001 15.5511Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8334 11.8333H28.1667V24.1667H15.8334V11.8333ZM16.8334 12.8333V23.1667H27.1667V12.8333H16.8334Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_59_2918",
    x: 0,
    y: 0,
    width: 85,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_59_2918"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_59_2918",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSExh);
export default __webpack_public_path__ + "static/media/s_exh.bf69614a2f6100b93968109988244d97.svg";
export { ForwardRef as ReactComponent };